/* trim-labels:
 *
 * Trim all labels
 *
 * Author: Niels Giesen
 * Copyright 2015 Berkeley Bridge
 *
 */
(function ($) {
  $(function () {
    $(document).on("bb:preHandleData", function (event, data) {
      if (typeof data == "undefined") return;

      if (data.groups) {
        $.each(data.groups, function (_, group) {
          $.each(group.controls, function (_, control) {
            if (control.controltype === "label")
              control.value = $.trim(control.value);
          });
        });
      }
    });
  });
})(jQuery);
